var UserCtrl = function (gettextCatalog, user) {
    this.gridOptions = {
        data: user,
        enableFiltering: true,
        columnDefs: [
            {
                field: 'email',
                enableColumnMenu: false,
                displayName: gettextCatalog.getString('Email')
            },
            {
                field: 'username',
                enableColumnMenu: false,
                displayName: gettextCatalog.getString('Firma')
            }
        ]
    };
};

module.exports = UserCtrl;



// WEBPACK FOOTER //
// ./client/src/app/modules/user/UserCtrl.js